"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var breathe_container_1 = __importDefault(require("../views/breathe-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var game_area_1 = require("../utilities/game-area");
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("../views/stack-container"));
var time_conversion_1 = require("../utilities/time-conversion");
var calculator_1 = require("../models/calculator");
var i18next_1 = __importDefault(require("i18next"));
var gsap_1 = require("gsap");
var PixiPlugin_1 = require("gsap/PixiPlugin");
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
var BREATHE_CYCLE_COUNT = 7;
var BREATHE_CYCLE_DURATION = 8500;
var BREATHE_CYCLE_INHALE_DURATION = BREATHE_CYCLE_DURATION * 0.5;
var BREATHE_CYCLE_EXHALE_DURATION = BREATHE_CYCLE_DURATION * 0.5;
var BREATHE_DURATION = BREATHE_CYCLE_COUNT * BREATHE_CYCLE_DURATION;
var BreatheState = /** @class */ (function (_super) {
    __extends(BreatheState, _super);
    function BreatheState(app, client, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(BreatheState.prototype, "breatheContainer", {
        get: function () {
            if (!this._breatheContainer) {
                this._breatheContainer = new breathe_container_1.default(this._app.loader.resources);
                this._breatheContainer.scale.set(0.5);
                this._breatheContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
            }
            return this._breatheContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BreatheState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stateMachine.pop();
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BreatheState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("breathe_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BreatheState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BreatheState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BreatheState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    BreatheState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.breatheContainer);
        this._app.stage.addChild(this.stackContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.interactive = true;
        this._app.stage.on("pointerdown", this.start.bind(this));
        this._dragonContainer.setIdleAnimation();
        this.breatheContainer.dragonSlot.addChild(this._dragonContainer);
        this.prepare();
        this._client.sendEvent("breathe_entered");
    };
    BreatheState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.breatheContainer);
        this._app.stage.removeChild(this.stackContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.interactive = false;
        this._app.stage.off("pointerdown");
        this.breatheContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    BreatheState.prototype.update = function (deltaTime) {
        this.breatheContainer.spine.update(deltaTime / 1000);
        if (this._startTime) {
            var elapsed = Date.now() - this._startTime;
            var remaining = BREATHE_DURATION - elapsed;
            if (remaining < 0) {
                this.congratulate();
                return;
            }
            this.tipLabel.text = i18next_1.default.t("breathe_countdown") + ": " + (0, time_conversion_1.timeConversion)(remaining);
        }
    };
    BreatheState.prototype.prepare = function () {
        this._startTime = null;
        this.setBreathe(i18next_1.default.t("breathe_caption"), false, 0);
        this.tipLabel.text = i18next_1.default.t("breathe_hint");
        this.stackContainer.layoutChildren();
    };
    BreatheState.prototype.start = function () {
        var _this = this;
        this._startTime = Date.now();
        this._app.stage.interactive = false;
        this.update(0);
        this._dragonContainer.setBreatheAnimation(BREATHE_CYCLE_COUNT, BREATHE_CYCLE_INHALE_DURATION, BREATHE_CYCLE_EXHALE_DURATION, function () {
            _this.setBreathe(i18next_1.default.t("breathe_in"), true, BREATHE_CYCLE_INHALE_DURATION);
        }, function () {
            _this.setBreathe(i18next_1.default.t("breathe_out"), false, BREATHE_CYCLE_EXHALE_DURATION);
        });
    };
    BreatheState.prototype.setBreathe = function (text, raised, duration) {
        this.titleLabel.text = text;
        this.stackContainer.layoutChildren();
        gsap_1.gsap.killTweensOf(this.titleLabel);
        gsap_1.gsap.fromTo(this.titleLabel, {
            y: raised ? 0 : -50
        }, {
            y: raised ? -50 : 0,
            duration: duration / 1000,
            ease: "Power1.easeInOut"
        });
    };
    BreatheState.prototype.congratulate = function () {
        var _this = this;
        this._startTime = null;
        var points = calculator_1.BREATHE_XP;
        this.titleLabel.text = i18next_1.default.t("breathe_finish_caption");
        this.tipLabel.text = i18next_1.default.t("breathe_finish_hint")
            .replace("[points]", points.toFixed());
        this.stackContainer.layoutChildren();
        this._client.adjustMeters({
            calmness: 30,
            nutrition: 0,
            hygiene: 0,
            energy: 0
        });
        this._client.award(points);
        this._client.synchronize();
        this._client.sendEvent("breathe_finished");
        gsap_1.gsap.to(this, {
            duration: 2,
            onComplete: function () {
                _this.stateMachine.pop();
            }
        });
    };
    return BreatheState;
}(state_1.default));
exports.default = BreatheState;
